export default __webpack_public_path__ + "static/media/DisAlignBottom.d27b7f57.svg";